{
  "statusLabels": {
    "active": "Actif",
    "suspended": "Suspendu",
    "closed": "Fermé"
  },
  "tierLabels": {
    "titanium": "Titanium",
    "platinum": "Platinum",
    "diamond": "Diamond",
    "enterprise": "Enterprise",
    "e2": "E2",
    "e3": "E3"
  },
  "list": {
    "header": {
      "title": "Marchands",
      "description": "Consultez, filtrez et effectuez des actions groupées sur les comptes marchands. Sur invitation uniquement — pas de bouton Créer. Les marchands suspendus restent cliquables pour les sections en lecture seule."
    },
    "toggle": {
      "showClosed": "Afficher les marchands fermés"
    },
    "legend": {
      "aria": "Légende des couleurs de ligne",
      "label": "Légende des lignes :",
      "suspended": "Suspendu",
      "new": "Nouveau (< 7 jours)"
    },
    "columns": {
      "name": "Nom",
      "email": "E-mail",
      "status": "Statut",
      "tier": "Niveau",
      "wallet": "Portefeuille",
      "creditTotal": "Crédit total",
      "creditUsed": "Crédit utilisé",
      "creditExpiry": "Expiration du crédit",
      "orders": "Commandes",
      "gmv": "GMV",
      "lastLogin": "Dernière connexion",
      "stores": "Boutiques",
      "autoPay": "Paiement auto",
      "autoRecharge": "Recharge auto",
      "transferBlock": "Blocage TG",
      "cardPayment": "Paiement par carte",
      "created": "Créé",
      "amCs": "AM & CS"
    },
    "filters": {
      "search": {
        "label": "Rechercher",
        "placeholder": "Nom, e-mail, entreprise…"
      },
      "status": {
        "label": "Statut"
      },
      "tier": {
        "label": "Niveau"
      },
      "transferBlock": {
        "label": "Blocage de transfert",
        "blocked": "Bloqué",
        "notBlocked": "Non bloqué"
      },
      "cardPayment": {
        "label": "Paiement par carte",
        "enabled": "Activé",
        "disabled": "Désactivé"
      },
      "dateRange": "Période"
    },
    "bulk": {
      "suspend": "Suspendre",
      "activate": "Activer",
      "setTier": "Définir le niveau",
      "setCredit": "Définir le crédit",
      "export": "Exporter CSV"
    },
    "actions": {
      "openAria": "Ouvrir le marchand {{name}}",
      "openTitle": "Ouvrir la fiche du marchand"
    },
    "amCs": {
      "am": "AM",
      "cs": "CS",
      "assign": "Assigner",
      "reassignTitle": "Réassigner AM & CS"
    },
    "boolean": {
      "on": "Activé",
      "off": "Désactivé"
    },
    "transferBlocked": {
      "label": "Blocage TG",
      "title": "Bloqué des groupes de transfert"
    },
    "empty": "Aucun marchand ne correspond à vos filtres.",
    "toast": {
      "noSelection": {
        "title": "Aucun marchand sélectionné",
        "description": "Sélectionnez au moins un marchand pour lancer cette action groupée."
      },
      "selectFirst": {
        "title": "Aucun marchand sélectionné",
        "suspend": "Sélectionnez au moins un marchand pour lancer la suspension groupée.",
        "activate": "Sélectionnez au moins un marchand pour lancer l'activation groupée.",
        "setTier": "Sélectionnez au moins un marchand pour changer le niveau.",
        "setCredit": "Sélectionnez au moins un marchand pour définir le crédit."
      },
      "approvalRequired": {
        "title": "Double approbation requise",
        "description_one": "Lot mis en attente. ID de demande {{requestId}} ; {{count}} marchand au-dessus du seuil {{threshold}}.",
        "description_other": "Lot mis en attente. ID de demande {{requestId}} ; {{count}} marchands au-dessus du seuil {{threshold}}."
      },
      "exportQueued": {
        "title": "Export mis en file d'attente",
        "description_one": "Tâche d'export {{jobId}} mise en file pour {{count}} marchand ({{format}}).",
        "description_other": "Tâche d'export {{jobId}} mise en file pour {{count}} marchands ({{format}})."
      },
      "applied": {
        "title": "Action groupée appliquée",
        "description_one": "{{count}} marchand mis à jour.",
        "description_other": "{{count}} marchands mis à jour."
      },
      "failed": {
        "title": "Échec de l'action groupée",
        "networkError": "Erreur réseau — vérifiez la connexion"
      }
    },
    "bulkModals": {
      "cancel": "Annuler",
      "pending": "Traitement…",
      "suspend": {
        "heading_one": "Suspension groupée de {{count}} marchand",
        "heading_other": "Suspension groupée de {{count}} marchands",
        "body_one": "Suspendre {{count}} marchand sélectionné. Bloque la connexion + les nouvelles commandes ; réactivation possible plus tard.",
        "body_other": "Suspendre {{count}} marchands sélectionnés. Bloque la connexion + les nouvelles commandes ; réactivation possible plus tard.",
        "reasonLabel": "Motif",
        "noteLabel": "Note — 2000 caractères maximum",
        "noteLabelRequired": "Note * — 2000 caractères maximum",
        "notePlaceholderRequired": "Obligatoire lorsque « Autre motif » est sélectionné (≥10 caractères).",
        "notePlaceholderOptional": "Facultatif.",
        "confirm": "Suspendre",
        "reasons": {
          "tosViolation": "Violation des conditions (CGU)",
          "fraudSuspected": "Fraude suspectée",
          "chargeback": "Rétrofacturation / litige prolongé",
          "merchantRequest": "À la demande du marchand",
          "complianceReview": "Examen de conformité en cours",
          "other": "Autre motif (préciser dans la note)"
        }
      },
      "activate": {
        "heading_one": "Activation groupée de {{count}} marchand",
        "heading_other": "Activation groupée de {{count}} marchands",
        "body_one": "Lever la suspension de {{count}} marchand sélectionné. Il pourra se connecter et passer des commandes dès la confirmation.",
        "body_other": "Lever la suspension de {{count}} marchands sélectionnés. Ils pourront se connecter et passer des commandes dès la confirmation.",
        "noteLabel": "Note — 2000 caractères maximum, facultatif",
        "confirm": "Activer"
      },
      "setTier": {
        "heading_one": "Changer le niveau de {{count}} marchand",
        "heading_other": "Changer le niveau de {{count}} marchands",
        "body_one": "Le nouveau niveau s'applique à {{count}} marchand sélectionné. Le niveau affecte l'échelle de crédit + l'autorisation de retrait.",
        "body_other": "Le nouveau niveau s'applique aux {{count}} marchands sélectionnés. Le niveau affecte l'échelle de crédit + l'autorisation de retrait.",
        "tierLabel": "Nouveau niveau",
        "confirm": "Appliquer le niveau"
      },
      "setCredit": {
        "heading_one": "Définir le crédit total de {{count}} marchand",
        "heading_other": "Définir le crédit total de {{count}} marchands",
        "body_one": "Appliquer le nouveau credit_total à {{count}} marchand sélectionné. Saisissez le montant en USD — le système le convertit en cents.",
        "body_other": "Appliquer le nouveau credit_total aux {{count}} marchands sélectionnés. Saisissez le montant en USD — le système le convertit en cents.",
        "amountLabel": "Crédit total (USD, ≥0)",
        "invalid": "Saisissez un nombre positif ou nul.",
        "centsHint": "= {{cents}} cents",
        "confirm": "Appliquer le crédit"
      }
    }
  },
  "tabsNav": {
    "ariaLabel": "Onglets des marchands",
    "all": {
      "label": "Tous",
      "description": "Tous les marchands sauf fermés."
    },
    "active": {
      "label": "Actif",
      "description": "Marchands dont le propriétaire est actif."
    },
    "suspended": {
      "label": "Suspendu",
      "description": "Marchands dont le propriétaire est suspendu. Sections en lecture seule toujours actives."
    },
    "new": {
      "label": "Nouveau (<7j)",
      "description": "Marchands créés au cours des 7 derniers jours (teinte de ligne)."
    },
    "closed": {
      "label": "Fermé",
      "description": "Marchands supprimés. Masqués par défaut — basculez sur la page de liste."
    }
  },
  "detail": {
    "back": "Retour aux Merchants",
    "missingId": "Identifiant du merchant manquant dans l'URL.",
    "loadingTab": "Chargement de l'onglet",
    "sectionsLabel": "Sections du détail du merchant",
    "error": "Échec du chargement du détail du merchant",
    "unknownError": "Erreur inconnue",
    "tabs": {
      "overview": "Vue d'ensemble",
      "wallet": "Portefeuille",
      "credit": "Crédit",
      "orders": "Commandes",
      "products": "Produits",
      "team-stores": "Équipe & Boutiques"
    },
    "charCounter": {
      "needChars_one": "Ajoutez encore {{count}} caractère",
      "needChars_other": "Ajoutez encore {{count}} caractères",
      "minChars_one": "Au moins {{count}} caractère",
      "minChars_other": "Au moins {{count}} caractères",
      "eligible": "Valide"
    },
    "reactivate": {
      "title": "Réactiver le merchant",
      "bodyPrefix": "Lever la suspension de ",
      "bodySuffix": ". Le merchant retrouve immédiatement un accès complet ; le journal d'audit enregistre l'opérateur et le motif.",
      "reasonLabel": "Motif (facultatif)",
      "cancel": "Annuler",
      "confirm": "Réactiver",
      "pending": "Réactivation…"
    },
    "unblockTransfer": {
      "title": "Débloquer le Transfer Group",
      "bodyPrefix": "Retirer l'indicateur de blocage pour ",
      "bodySuffix": ". Le merchant revient dans la liste des destinataires des Transfer Groups dès la confirmation. Le journal d'audit enregistre qui a débloqué et pourquoi.",
      "existingReasonLabel": "Motif de blocage initial :",
      "reasonLabel": "Motif de déblocage",
      "reasonRange": "(10..{{max}} caractères)",
      "placeholder": "Ex. : Examen de conformité terminé, le merchant est éligible à reprendre son activité.",
      "cancel": "Annuler",
      "confirm": "Débloquer",
      "pending": "Déblocage…"
    },
    "forceProduct": {
      "titleDelete": "Suppression forcée du produit",
      "titleUnpublish": "Dépublication forcée du produit",
      "bodyPrefix": "Produit ",
      "bodyMiddle": " du merchant ",
      "bodyEnd": ".",
      "noteDelete": "La suppression forcée le marque DELETED_BY_ADMIN — irréversible.",
      "noteUnpublish": "La dépublication forcée masque le produit de la vitrine ; il pourra être republié plus tard.",
      "codeLabel": "Code de motif",
      "codes": {
        "POLICY_VIOLATION": "Violation de la politique",
        "COPYRIGHT": "Violation de droits d'auteur",
        "QUALITY": "Problème de qualité",
        "OTHER": "Autre motif"
      },
      "reasonLabel": "Motif détaillé",
      "reasonRange": "(10..{{max}} caractères)",
      "reasonPlaceholderDelete": "Décrivez en détail le motif de la suppression forcée de ce produit…",
      "reasonPlaceholderUnpublish": "Décrivez en détail le motif de la dépublication forcée de ce produit…",
      "notifyEmail": "Envoyer un e-mail au merchant",
      "notifyInApp": "Notification dans l'application",
      "confirmNameLabel": "Saisissez le nom du merchant pour confirmer la suppression :",
      "nameMismatch": "Le nom du merchant ne correspond pas.",
      "cancel": "Annuler",
      "pending": "Traitement…",
      "confirmDelete": "Suppression forcée",
      "confirmUnpublish": "Dépublication forcée"
    },
    "pricingProfile": {
      "title": "Profil tarifaire",
      "helper": "Étiquette informative uniquement — elle ne modifie jamais la formule de prix. Utilisée pour le reporting et la bascule 2027.",
      "profiles": {
        "legacy_v2": "Legacy V2",
        "standard": "Standard V3"
      },
      "editLabel": "Changer le profil",
      "selectLabel": "Profil tarifaire",
      "reasonLabel": "Raison (obligatoire)",
      "reasonPlaceholder": "Pourquoi cette étiquette change-t-elle ?",
      "reasonRequired": "Une raison est requise.",
      "save": "Enregistrer le profil",
      "saving": "Enregistrement…",
      "cancel": "Annuler",
      "auditNote": "Chaque modification est enregistrée dans la piste d'audit.",
      "noRecalcNote": "Les commandes confirmées conservent leur prix capturé — cette étiquette ne les recalcule pas.",
      "savedToast": "Profil tarifaire mis à jour.",
      "errorToast": "Impossible de mettre à jour le profil tarifaire."
    }
  },
  "stickyHeader": {
    "actions": {
      "editProfile": "Modifier le profil",
      "reactivate": "Réactiver",
      "suspend": "Suspendre",
      "blockTransfer": "Bloquer du Transfer Group",
      "unblockTransfer": "Débloquer du Transfer Group",
      "blockTransferTitle": "Mettre en quarantaine des transfer groups du cycle de coûts",
      "unblockTransferTitle": "Lever le blocage du Transfer Group (POST /:id/transfer-unblock)",
      "impersonate": "Se faire passer pour"
    }
  },
  "overview": {
    "aria": {
      "panel": "Aperçu du marchand"
    },
    "profile": {
      "heading": "Profil",
      "name": "Nom",
      "email": "Email",
      "phone": "Téléphone",
      "businessName": "Nom de l'entreprise",
      "taxId": "Numéro fiscal",
      "businessAddress": "Adresse de l'entreprise"
    },
    "kpis": {
      "totalOrders": "Total des commandes",
      "totalRevenue": "Revenu total",
      "products": "Produits",
      "connectedStores": "Boutiques connectées"
    },
    "wallet": {
      "balance": "Solde du portefeuille",
      "creditTotal": "Crédit total",
      "pendingTopups": "Recharges en attente",
      "withdraw": "Retrait",
      "enabled": "Activé",
      "disabled": "Désactivé",
      "withdrawHintEnterprise": "Niveau Enterprise",
      "withdrawHintLocked": "Verrouillé : niveau non-Enterprise",
      "withdrawHintEnabled": "Activé — gérer dans l'onglet Wallet",
      "withdrawHintDisabled": "Désactivé par défaut — activer par marchand dans l'onglet Wallet"
    },
    "notes": {
      "heading": "Notes internes",
      "adminOnly": "(admin uniquement)"
    },
    "activity": {
      "heading": "Activité récente",
      "subtitle": "10 derniers événements du journal d'audit",
      "errorFallback": "Impossible de charger le flux d'activité",
      "empty": "Aucun événement enregistré pour ce marchand pour le moment.",
      "system": "Système",
      "dot": {
        "securityAudit": "Audit de sécurité",
        "adminAction": "Action admin",
        "ownerAction": "Action du propriétaire marchand"
      },
      "relative": {
        "justNow": "à l'instant",
        "minutesAgo_one": "il y a {{count}} minute",
        "minutesAgo_other": "il y a {{count}} minutes",
        "hoursAgo_one": "il y a {{count}} heure",
        "hoursAgo_other": "il y a {{count}} heures",
        "daysAgo_one": "il y a {{count}} jour",
        "daysAgo_other": "il y a {{count}} jours"
      }
    }
  },
  "wallet": {
    "aria": {
      "panel": "Portefeuille et facturation"
    },
    "errorFallback": "Échec du chargement des détails du portefeuille",
    "cards": {
      "balance": "Solde du portefeuille",
      "creditRemaining": "Crédit restant",
      "pendingTopups": "Recharges en attente",
      "expires": "Expire le {{date}}",
      "noExpiry": "Aucune expiration définie",
      "pendingRequests_one": "{{count}} demande en attente",
      "pendingRequests_other": "{{count}} demandes en attente"
    },
    "withdraw": {
      "heading": "Autorisation de retrait",
      "enterpriseOnly": "(Enterprise uniquement)",
      "enabled": "Activé",
      "disabled": "Désactivé",
      "dailyLimit": "Limite quotidienne :",
      "toggleLabel": "Autoriser ce marchand à retirer",
      "offByDefaultHint": "Désactivé par défaut. Le marchand voit le bouton Retrait uniquement lorsqu'il est activé.",
      "save": "Enregistrer",
      "saving": "Enregistrement…",
      "saved": "Autorisation de retrait mise à jour",
      "saveError": "Échec de la mise à jour de l'autorisation de retrait",
      "loadError": "Impossible de lire l'autorisation de retrait actuelle. La modification est désactivée afin qu'une lecture échouée ne soit pas enregistrée comme un changement."
    },
    "cardPayment": {
      "heading": "Paiement par carte",
      "toggleLabel": "Autoriser ce marchand à payer par carte enregistrée",
      "offByDefaultHint": "Désactivé par défaut. Une fois activé, le marchand règle ses commandes et factures directement par carte enregistrée plutôt que depuis son portefeuille. Les marchands facturés ne peuvent régler que les factures, jamais les commandes individuelles.",
      "save": "Enregistrer",
      "saving": "Enregistrement…",
      "saved": "Autorisation de paiement par carte mise à jour",
      "saveError": "Échec de la mise à jour de l'autorisation de paiement par carte",
      "loadError": "Impossible de lire l'autorisation de paiement par carte actuelle. La modification est désactivée afin qu'une lecture échouée ne soit pas enregistrée comme un changement.",
      "maxPerOrder": "Plafond par débit (USD)",
      "maxPerDay": "Plafond quotidien (USD)",
      "noLimitHint": "Laisser vide signifie sans plafond. Un débit par carte ne peut pas être remboursé sur la carte depuis ici : un plafond limite le coût d'une erreur.",
      "noLimitConfirm": "Je confirme : plafond vide = aucune limite",
      "noLimitRequired": "Un plafond vide signifie des dépenses par carte illimitées — cochez la case pour confirmer, ou saisissez un montant."
    },
    "creditPolicy": {
      "heading": "Politique de crédit",
      "autoPay": "Paiement auto",
      "autoRecharge": "Recharge auto",
      "totalCredit": "Crédit total",
      "creditUsed": "Crédit utilisé",
      "on": "Activé",
      "off": "Désactivé"
    },
    "billingModes": {
      "PREPAID": {
        "label": "Prépayé (recharge préalable)",
        "hint": "Le marchand recharge le solde au préalable ; aucune facture émise."
      },
      "CREDIT": {
        "label": "Crédit (recharge auto)",
        "hint": "Le portefeuille se recharge automatiquement depuis la passerelle enregistrée ; échec de recharge → suspension."
      },
      "INVOICE": {
        "label": "Facture (conditions NET)",
        "hint": "Émet des factures périodiques ; NET-N jours pour payer après émission."
      }
    },
    "switcher": {
      "heading": "Mode de facturation",
      "description": "Le mode régit le fonctionnement du portefeuille/crédit/facture. Changez rapidement ici — la configuration détaillée et l'historique des factures sont sur la page complète.",
      "newMode": "Nouveau mode",
      "reasonLabel": "Motif (audit, au moins 10 caractères)",
      "selectTitleAdmin": "Choisissez un nouveau mode puis saisissez un motif pour confirmer",
      "selectTitleReadonly": "Seuls les admins peuvent changer le mode (les comptables sont en lecture seule)",
      "reasonPlaceholder": "ex. : passer en INVOICE NET-7 selon l'accord contractuel.",
      "detailLink": "Ouvrir la page complète Finances et factures →",
      "submitting": "Changement…",
      "submit": "Confirmer le changement de mode",
      "submitTitleNotAdmin": "Seuls les admins/superadmins peuvent changer le mode",
      "submitTitleNotDirty": "Choisissez d'abord un mode différent de l'actuel",
      "submitTitleReasonShort_one": "Saisissez encore {{count}} caractère pour le motif",
      "submitTitleReasonShort_other": "Saisissez encore {{count}} caractères pour le motif",
      "submitTitleReady": "Confirmer le changement de mode de facturation",
      "successMessage": "Basculé vers {{mode}}.",
      "networkError": "Erreur réseau"
    },
    "permission": {
      "readOnly": "Lecture seule — permission de facturation manquante"
    }
  },
  "orders": {
    "aria": {
      "panel": "Commandes du marchand"
    },
    "errorFallback": "Échec du chargement des commandes",
    "columns": {
      "orderNumber": "N° commande",
      "status": "Statut",
      "grandTotal": "Total général",
      "created": "Créée"
    },
    "empty": "Aucune commande trouvée pour ce marchand.",
    "pager": {
      "pageInfo_one": "Page {{page}} · {{count}} ligne",
      "pageInfo_other": "Page {{page}} · {{count}} lignes",
      "prev": "Préc.",
      "next": "Suiv."
    },
    "statusLabels": {
      "draft": "Brouillon",
      "pending_payment": "Paiement en attente",
      "pending_emb_payment": "Paiement broderie en attente",
      "confirmed": "Confirmée",
      "assigned": "Assignée",
      "accepted": "Acceptée",
      "in_production": "En production",
      "quality_check": "Contrôle qualité",
      "ready_to_ship": "Prête à expédier",
      "on_hold": "En attente",
      "pending_reassignment": "Réassignation en attente",
      "shipped": "Expédiée",
      "partially_shipped": "Partiellement expédiée",
      "delivered": "Livrée",
      "returned_partial": "Retournée (partielle)",
      "partially_cancelled": "Partiellement annulée",
      "cancelled": "Annulée",
      "attention_required": "Attention requise",
      "unknown": "Inconnu"
    }
  },
  "products": {
    "aria": {
      "panel": "Produits du marchand"
    },
    "errorFallback": "Échec du chargement des produits",
    "columns": {
      "avatar": "Avatar",
      "title": "Titre",
      "status": "Statut",
      "published": "Publié",
      "baseCost": "Coût de base",
      "created": "Créé",
      "actions": "Actions"
    },
    "empty": "Aucun produit trouvé pour ce marchand.",
    "publishedBadge": "Publié",
    "draftBadge": "Brouillon",
    "actions": {
      "forceUnpublish": "Forcer la dépublication",
      "forceDelete": "Forcer la suppression",
      "handlerUnavailable": "Cette action n'est pas disponible dans ce contexte.",
      "unpublishNoTarget": "Le produit est à l'état Brouillon (non publié) — rien à dépublier.",
      "unpublishReady": "Masquer le produit de la vitrine. Vous pourrez le republier plus tard.",
      "deleteReady": "La suppression forcée marque DELETED_BY_ADMIN — elle est irréversible.",
      "forceUnpublishAria": "Forcer la dépublication — {{reason}}",
      "forceDeleteAria": "Forcer la suppression — {{reason}}"
    },
    "pager": {
      "pageInfo_one": "Page {{page}} · {{count}} ligne",
      "pageInfo_other": "Page {{page}} · {{count}} lignes",
      "prev": "Préc.",
      "next": "Suiv."
    },
    "statusLabels": {
      "draft": "Brouillon",
      "active": "Actif",
      "inactive": "Inactif",
      "archived": "Archivé",
      "deleted": "Supprimé",
      "published": "Publié",
      "unpublished": "Dépublié",
      "pending": "En attente"
    }
  },
  "teamStores": {
    "aria": {
      "panel": "Équipe et boutiques du marchand"
    },
    "errorFallback": "Échec du chargement de l'équipe et des boutiques",
    "readonlyBanner": "Remarque : la section Équipe et Boutiques est en lecture seule — les admins Printway n'ajoutent / modifient / suppriment pas de membres (, autonomie du marchand). Suspendre le marchand gèle automatiquement tous les membres de l'équipe.",
    "team": {
      "heading": "Membres de l'équipe",
      "empty": "Aucun membre d'équipe.",
      "columns": {
        "name": "Nom",
        "email": "Email",
        "role": "Rôle",
        "status": "Statut",
        "joined": "Rejoint"
      }
    },
    "stores": {
      "heading": "Boutiques connectées",
      "empty": "Aucune boutique connectée.",
      "openLink": "Ouvrir le détail de la boutique",
      "columns": {
        "store": "Boutique",
        "platform": "Plateforme",
        "domain": "Domaine",
        "status": "Statut",
        "connected": "Connectée",
        "actions": "Actions"
      }
    },
    "roleLabels": {
      "owner": "Propriétaire",
      "accountant": "Comptable",
      "operator": "Opérateur",
      "viewer": "Observateur",
      "member": "Membre"
    },
    "teamStatusLabels": {
      "pending": "En attente",
      "active": "Actif",
      "suspended": "Suspendu",
      "removed": "Retiré",
      "inactive": "Inactif"
    },
    "storeStatusLabels": {
      "Active": "Active",
      "Disconnected": "Déconnectée",
      "Frozen": "Gelée",
      "Inactive": "Inactive"
    },
    "platformLabels": {
      "shopify": "Shopify",
      "etsy": "Etsy",
      "woocommerce": "WooCommerce",
      "tiktok": "TikTok",
      "amazon": "Amazon",
      "manual": "Manuel",
      "unknown": "Inconnu"
    }
  },
  "modals": {
    "common": {
      "cancel": "Annuler",
      "charsNeeded_one": "{{count}} caractère supplémentaire requis",
      "charsNeeded_other": "{{count}} caractères supplémentaires requis",
      "ready": "Prêt",
      "networkError": "Erreur réseau — vérifiez la connexion",
      "minCharsPlaceholder": "Au moins {{min}} caractères…",
      "reasonWithMinPlaceholder": "Saisissez un motif (au moins {{min}} caractères)…"
    },
    "blockTransfer": {
      "title": "Bloquer le merchant du Transfer Group",
      "description": {
        "withName": "Le merchant {{name}} sera retiré de la liste des destinataires de tous les Transfer Groups. Cette action n'affecte PAS la connexion, les commandes ni le portefeuille — elle empêche seulement le merchant d'être déplacé dans un groupe de transfert de coûts.",
        "withoutName": "Le merchant sera retiré de la liste des destinataires de tous les Transfer Groups. Cela n'affecte PAS la connexion / les commandes / le portefeuille."
      },
      "reasonLegend": "Motif du blocage",
      "reasons": {
        "fraud_suspected": {
          "label": "Fraude suspectée",
          "hint": "Signes de fraude détectés — à investiguer avant d'autoriser un transfert."
        },
        "abnormal_pattern": {
          "label": "Schéma de transactions anormal",
          "hint": "Le schéma de volume / fréquence des commandes s'écarte fortement de la référence."
        },
        "compliance_review": {
          "label": "Examen de conformité en cours",
          "hint": "L'équipe conformité examine le dossier — les transferts sont suspendus pendant l'examen."
        },
        "merchant_request": {
          "label": "À la demande du merchant",
          "hint": "Le merchant a demandé le blocage — par ex. mise en pause de son activité."
        },
        "other": {
          "label": "Autre motif",
          "hint": "Précisez-le dans le champ note ci-dessous."
        }
      },
      "noteLabel": "Note",
      "notePlaceholder": {
        "required": "Puisque vous avez choisi « Autre motif », veuillez décrire en détail (au moins 10 caractères)…",
        "optional": "Note complémentaire (facultatif). {{hint}}"
      },
      "confirm": "Bloquer du Transfer Group",
      "submitting": "Blocage…"
    },
    "forceDeleteProduct": {
      "title": "Supprimer définitivement le produit",
      "description": {
        "withProduct": "Cette action est IRRÉVERSIBLE. Le produit {{product}} sera marqué DELETED_BY_ADMIN et disparaîtra du catalogue du merchant {{merchant}}.",
        "withoutProduct": "Cette action est IRRÉVERSIBLE. Le produit sera marqué DELETED_BY_ADMIN et disparaîtra du catalogue du merchant {{merchant}}."
      },
      "reasonCodeLabel": "Code du motif",
      "reasonCodes": {
        "POLICY_VIOLATION": "Violation de politique (POLICY_VIOLATION)",
        "COPYRIGHT": "Droit d'auteur (COPYRIGHT)",
        "QUALITY": "Qualité (QUALITY)",
        "OTHER": "Autre (OTHER)"
      },
      "detailLabel": "Motif détaillé",
      "notifyEmail": "Envoyer un e-mail au merchant",
      "notifyInApp": "Envoyer une notification in-app au merchant",
      "confirmNameLabel": "Pour confirmer, saisissez le nom exact du merchant {{name}}",
      "nameMismatch": "Le nom ne correspond pas.",
      "confirm": "Supprimer définitivement le produit",
      "submitting": "Suppression…"
    },
    "freezeWallet": {
      "title": {
        "freeze": "Geler le portefeuille du merchant",
        "unfreeze": "Dégeler le portefeuille du merchant"
      },
      "description": {
        "freezeWithName": "Le portefeuille du merchant {{name}} passera à Suspended. Toutes les nouvelles transactions de débit seront rejetées.",
        "freezeWithoutName": "Le portefeuille du merchant passera à Suspended. Toutes les nouvelles transactions de débit seront rejetées.",
        "unfreezeWithName": "Le portefeuille du merchant {{name}} sera rouvert (Active). Les portefeuilles en récupération de chargeback ne sont pas affectés.",
        "unfreezeWithoutName": "Le portefeuille du merchant repassera à Active. Les portefeuilles en récupération de chargeback ne sont pas affectés."
      },
      "currencyScope": "S'applique uniquement au portefeuille en devise {{currency}}.",
      "reasonLabel": "Motif",
      "confirm": {
        "freeze": "Geler le portefeuille",
        "unfreeze": "Dégeler le portefeuille"
      },
      "submitting": "Traitement…"
    },
    "impersonate": {
      "title": {
        "withLabel": "Se connecter en tant que Merchant — {{name}}",
        "plain": "Se connecter en tant que Merchant"
      },
      "description": "Vous vous connecterez au nom du merchant pour le support / l'investigation. Chaque action est entièrement journalisée dans l'audit.",
      "supportDenied": "Les comptes Support Admin ne sont pas autorisés à impersonate. Veuillez contacter un Super Admin si nécessaire.",
      "warningBanner": {
        "title": "Vous serez connecté en tant que ce merchant. Toutes les actions sont journalisées.",
        "subtitle": "Chaque action de cette session sera enregistrée dans le journal d'audit."
      },
      "modePreview": {
        "title": "Mode : lecture seule + liste blanche de 3 actions",
        "ordersView": "orders:view — voir les commandes",
        "merchantsView": "merchants:view — voir le profil merchant",
        "storesView": "stores:view — voir les stores",
        "note": "Toute autre action d'écriture sera rejetée par le serveur avec le code IMPERSONATE_READONLY pendant la session d'impersonation."
      },
      "cookieInfo": {
        "title": "Le cookie sera défini sur le sous-domaine :",
        "expiry": "La session d'impersonation expire après 30 minutes."
      },
      "reasonLabel": "Motif (audit, ≥ {{min}} caractères)",
      "confirm": "Se connecter en tant que merchant",
      "submitting": "Initialisation…"
    },
    "suspend": {
      "title": "Suspendre le merchant",
      "description": {
        "withName": "Le merchant {{name}} passera à l'état Suspended. Tous les portefeuilles seront gelés et les commandes en cours seront retenues.",
        "withoutName": "Le merchant passera à l'état Suspended. Portefeuilles gelés, commandes en cours retenues."
      },
      "dualApprovalBanner": "Lot > 5 merchants — une double approbation (dual approval,) est requise avant d'appliquer à toute la sélection.",
      "previewSummary": "{{orders}} commandes en cours seront retenues, {{stores}} stores arrêtent la synchronisation, {{wallets}} portefeuilles verrouillés.",
      "previewError": "Impossible de charger les données d'aperçu",
      "previewLoading": "Chargement de l'aperçu…",
      "reasonCodeLabel": "Code du motif",
      "reasonCodes": {
        "FRAUD": "Fraude (FRAUD)",
        "NON_PAYMENT": "Non-paiement (NON_PAYMENT)",
        "POLICY_VIOLATION": "Violation de politique (POLICY_VIOLATION)",
        "CHARGEBACK": "Chargeback",
        "KYC_FAILURE": "Échec KYC (KYC_FAILURE)",
        "SECURITY": "Sécurité (SECURITY)",
        "VOLUNTARY_REQUEST": "Demande volontaire (VOLUNTARY_REQUEST)",
        "OTHER": "Autre (OTHER)"
      },
      "reasonLabel": "Motif de la suspension",
      "notify": "Notifier le merchant (e-mail + in-app)",
      "confirm": "Suspendre le merchant",
      "submitting": "Suspension…"
    },
    "setEditCredit": {
      "title": {
        "edit": "Modifier la limite de crédit",
        "new": "Accorder une limite de crédit"
      },
      "description": {
        "withName": "Merchant {{name}}. Toutes les modifications sont enregistrées dans l'audit.",
        "withoutName": "Toutes les modifications sont enregistrées dans l'audit."
      },
      "limitLabel": "Limite (USD)",
      "periodLabel": "Période (jours)",
      "remindAtLabel": "Rappel à l'utilisation (USD)",
      "remindAtPlaceholder": "Laisser vide pour aucun rappel",
      "limitWarning": "La limite de crédit ne peut être qu'augmentée, pas diminuée.",
      "notify": "Notifier le merchant lors de l'octroi/modification",
      "autoLock": "Verrouillage auto en cas de retard (auto-lock overdue,)",
      "autoReset": "Réinitialisation auto de la période (auto-reset)",
      "reasonLabel": "Motif",
      "confirm": {
        "edit": "Enregistrer les modifications",
        "new": "Accorder la limite"
      },
      "submitting": "Enregistrement…"
    }
  },
  "edit": {
    "missingId": "Identifiant du merchant manquant dans l'URL.",
    "noPermission": "Vous n'avez pas la permission de modifier les merchants.",
    "loading": "Chargement du merchant à modifier…",
    "loadError": "Échec du chargement du merchant : {{message}}",
    "header": {
      "title": "Modifier le profil du merchant",
      "subtitle": "Modification de {{name}} · les changements sont enregistrés dans la piste d'audit du merchant (MERCHANT_PROFILE_UPDATED)."
    },
    "savedToast": "Enregistré · {{time}}",
    "fields": {
      "businessName": "Nom de l'entreprise",
      "phone": "Téléphone",
      "taxId": "Numéro fiscal",
      "street": "Rue",
      "city": "Ville",
      "region": "Région",
      "postalCode": "Code postal",
      "country": "Pays (ISO-3166 alpha-2)",
      "contractLegalEntity": "Entité juridique contractante"
    },
    "addressLegend": "Adresse de l'entreprise (facultatif — tout effacer pour supprimer)",
    "reasonLabel": "Motif du changement (facultatif, max 500 caractères — enregistré dans les métadonnées d'audit)",
    "validation": {
      "businessNameMin": "Le nom de l'entreprise doit comporter au moins 2 caractères.",
      "phoneFormat": "Le téléphone doit être au format E.164 (ex. +14155551234) ou vide.",
      "fixHighlighted": "Corrigez les champs en surbrillance et réessayez.",
      "unknownError": "Erreur inconnue"
    },
    "dirtyCount_one": "{{count}} champ modifié",
    "dirtyCount_other": "{{count}} champs modifiés",
    "noChanges": "Aucune modification en attente",
    "confirmDiscard": "Les modifications non enregistrées seront perdues. Annuler quand même ?",
    "cancel": "Annuler",
    "save": "Enregistrer les modifications",
    "saving": "Enregistrement…",
    "contractEntity": {
      "loading": "Chargement…",
      "systemDefault": "Entité par défaut du système",
      "defaultTag": "{{name}} (par défaut)",
      "unknownEntity": "Entité inconnue ({{id}})",
      "hint": "Les factures, reçus et demandes de paiement sont émis par cette entité. Conservez la valeur par défaut sauf si le marchand a un contrat dédié."
    }
  }
}
